<template>
    <div>
        <paketrezervasyonlistesi :PaketId="'0'" :MasterTurId="'0'" />
    </div>
  </template>
  
  
  <script>

  import paketrezervasyonlistesi from './rezervasyon/paketrezervasyonlistesi.vue';
    export default {
      components: {
        paketrezervasyonlistesi
      },

      beforeMount: beforeMount,
      methods: {},
      data() {},
  
      watch: {},
      mounted() {
  
      }
    }
  
    function beforeMount() { 
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));     
  
    }
  
  </script>